import { Link } from "wouter";
import { useAuth } from "../auth/AuthContext";
import { ThemeToggle } from "./ThemeToggle";

interface TopBarProps {
  /** Whether the narrow-viewport nav drawer is open — see useNavDrawer. */
  isNavOpen: boolean;
  onToggleNav: () => void;
}

export function TopBar({ isNavOpen, onToggleNav }: TopBarProps) {
  const { session, logout } = useAuth();

  return (
    <header className="top-bar">
      {/* Hidden by shell.css above the mobile breakpoint — desktop keeps the
          sidebar statically visible and never needs this. */}
      <button
        type="button"
        className="top-bar__nav-toggle"
        onClick={onToggleNav}
        aria-expanded={isNavOpen}
        aria-controls="primary-navigation"
        aria-label={isNavOpen ? "Close navigation" : "Open navigation"}
      >
        <svg viewBox="0 0 24 24" width="20" height="20" aria-hidden="true" focusable="false">
          <g stroke="currentColor" strokeWidth="2" strokeLinecap="round">
            <path d="M3 6h18M3 12h18M3 18h18" />
          </g>
        </svg>
      </button>

      <div className="top-bar__brand">
        <span className="top-bar__brand-mark" aria-hidden="true" />
        <span className="top-bar__brand-name">Comebye</span>
      </div>

      <div className="top-bar__spacer" />

      {/* The fleet switcher is gone (ADR-0035 M1 PR-D): the tenant comes from
          the session, so there is nothing to switch between. */}
      <ThemeToggle />

      {session && (
        <div className="top-bar__user">
          {/* Account settings (profile + change password) is reachable by
           * every signed-in role, not just admins — the display name itself
           * is a second way into `/settings` alongside NavSidebar's pinned
           * Settings/Account/Billing link. */}
          <Link href="/settings" className="top-bar__user-name">
            {session.displayName}
          </Link>
          <button type="button" className="top-bar__signout" onClick={() => void logout()}>
            Sign out
          </button>
        </div>
      )}
    </header>
  );
}
